import { type TranscriptSearchedItem } from '~/swr-hooks/clips/transcript/search/types';

export const isInRange = (numberToCheck: number, range: [number, number]) =>
  range[0] <= numberToCheck && numberToCheck <= range[1];

export const isTimeInSearchResults = (results: TranscriptSearchedItem[], startTimeMs: number, endTimeMs: number) =>
  results.some(
    (result) =>
      result.type === 'result' &&
      (isInRange(startTimeMs, [result.startTimeMs, result.endTimeMs]) ||
        isInRange(endTimeMs, [result.startTimeMs, result.endTimeMs])),
  );
